export const environment = {
  production: true,
  baseURL: "https://stgapi.reglakeoptimum.com/",
  baseUrl: "https://stg.reglakeoptimum.com/"
  //baseURL: "http://151.106.32.30/RegLakeAPI/",
  //baseUrl: "http://151.106.32.30/RegLakePortal/"
  //baseURL: "https://vserver.co.in:8443/",
  //baseUrl: "https://vserver.co.in:8443/"
  // baseURL: "https://api.reglakeoptimum.com/",
  // baseUrl: "https://reglakeoptimum.com/"
  //baseURL: "http://151.106.32.30:8010/",
  //baseUrl: "http://151.106.32.30/"
};
